// twilio-chat-client.js
import { axios } from '../axios';

let twilioClientPromise = null;

export const getTwilioClient = () => {
    if (twilioClientPromise) return twilioClientPromise;

    twilioClientPromise = Promise.all([
        axios.get('/chat/generate-token'),
        import('twilio-chat')
    ])
        .then(([{ data }, twilioModule]) => {
            const TwilioChatClient = twilioModule.Client || twilioModule.default?.Client;
            return new TwilioChatClient(data.data.token);
        })
        .catch(err => {
            twilioClientPromise = null;
            throw err;
        });

    return twilioClientPromise;
};
